// extracted by mini-css-extract-plugin
module.exports = {"name":"ComponentInfo__name__3uPow","category":"ComponentInfo__category__2H74n","tooltip":"ComponentInfo__tooltip__2fY3J","popover":"ComponentInfo__popover__Ztqk0"};